module.exports = "<ul gw-partial=\"Item\"></ul>\n"